import React from "react";
import {
  EntityProfileCompactFieldGroup,
  EntityProfileCompactFieldRow,
  EntityProfileFieldSection,
} from "../../../../../entityProfileModal/components/EntityProfileFieldLayout";
import PatientProfileInlineEditableRow from "../../../../../entityProfileModal/components/EntityProfileInlineEditableRow";

export function InformationBlock(props: { children: React.ReactNode; title?: string }) {
  return (
    <EntityProfileFieldSection
      title={props.title}
      titleProps={{ fontSize: "20px", fontWeight: 500, mb: 3 }}
    >
      <EntityProfileCompactFieldGroup>{props.children}</EntityProfileCompactFieldGroup>
    </EntityProfileFieldSection>
  );
}

export function InformationEditableRow<TField extends string>(props: {
  activeField: TField | null;
  children: React.ReactNode;
  field: TField;
  isEditing: boolean;
  label: string;
  value: React.ReactNode;
  onActivate: (field: TField) => void;
  onCancel: () => void;
  onCommit: (field: TField) => void;
}) {
  return (
    <PatientProfileInlineEditableRow
      activeField={props.activeField}
      emptyPlaceholder={props.isEditing}
      field={props.field}
      isEditable={props.isEditing}
      label={props.label}
      value={props.value}
      variant="compact"
      onActivate={props.onActivate}
      onCancel={props.onCancel}
      onCommit={() => props.onCommit(props.field)}
    >
      {props.children}
    </PatientProfileInlineEditableRow>
  );
}

export function InformationReadonlyRow(props: {
  isEditing?: boolean;
  label: string;
  value: React.ReactNode;
  onClick?: () => void;
}) {
  const isClickable = props.isEditing === true && props.onClick !== undefined;

  return (
    <EntityProfileCompactFieldRow
      isClickable={isClickable}
      label={props.label}
      value={props.value}
      onClick={props.onClick}
    />
  );
}
